import React, { useState } from 'react';
import { faqs } from '../mockData';
import { HelpCircle, Dumbbell, Heart, Salad } from 'lucide-react';

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <section className="bg-gradient-to-br from-[#F8F9FA] to-white py-20">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Column - FAQs */}
          <div className="space-y-8 scroll-reveal-left">
            {/* Section Header */}
            <div>
              <p className="text-sm font-bold text-[#fff301] mb-4 uppercase tracking-wider flex items-center gap-2">
                <span className="inline-block w-3 h-3 bg-[#fff301] rounded-full"></span>
                DÚVIDAS? NÓS TEMOS AS RESPOSTAS!
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-black">
                Perguntas frequentes
              </h2>
            </div>

            {/* FAQ Accordion */}
            <div className="space-y-4">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="border-b border-gray-300 pb-4"
                >
                  <button
                    onClick={() => toggleFaq(faq.id)}
                    className="w-full flex justify-between items-center text-left py-4 group"
                  >
                    <span className="text-lg font-medium text-gray-900 group-hover:text-[#fff301] group-hover:drop-shadow-[0_1px_1px_rgba(0,0,0,0.3)] transition-all pr-4">
                      {faq.question}
                    </span>
                    <span className={`text-2xl font-bold transition-all duration-300 flex-shrink-0 ${
                      openFaq === faq.id ? 'text-[#fff301] rotate-45' : 'text-[#fff301]'
                    }`}>
                      +
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openFaq === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <p className="text-gray-700 pb-4 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Fun Question Mark Illustration - Hidden on mobile */}
          <div className="relative hidden md:flex items-center justify-center scroll-reveal-right">
            <div className="relative">
              {/* Main Question Mark Circle */}
              <div className="w-72 h-72 md:w-96 md:h-96 rounded-full bg-gradient-to-br from-[#fff301] to-[#e6dd01] flex items-center justify-center shadow-2xl relative overflow-hidden">
                {/* Animated background circles */}
                <div className="absolute top-4 right-8 w-16 h-16 bg-white/20 rounded-full animate-pulse"></div>
                <div className="absolute bottom-12 left-4 w-12 h-12 bg-white/30 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
                <div className="absolute top-1/3 left-8 w-8 h-8 bg-white/20 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
                
                {/* Big Question Mark */}
                <span className="text-[180px] md:text-[240px] font-black text-white drop-shadow-lg select-none" style={{lineHeight: 1}}>
                  ?
                </span>
              </div>
              
              {/* Floating Icons around the question mark */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-white rounded-2xl shadow-lg flex items-center justify-center animate-bounce" style={{animationDuration: '2s'}}>
                <Dumbbell className="w-8 h-8 text-[#fff301]" />
              </div>
              
              <div className="absolute -bottom-2 -left-4 w-14 h-14 bg-white rounded-2xl shadow-lg flex items-center justify-center animate-bounce" style={{animationDuration: '2.5s', animationDelay: '0.3s'}}>
                <Heart className="w-7 h-7 text-red-500" />
              </div>
              
              <div className="absolute top-1/2 -right-6 w-12 h-12 bg-white rounded-xl shadow-lg flex items-center justify-center animate-bounce" style={{animationDuration: '3s', animationDelay: '0.6s'}}>
                <Salad className="w-6 h-6 text-green-500" />
              </div>
              
              {/* Small decorative dots */}
              <div className="absolute top-8 left-0 w-4 h-4 bg-[#fff301] rounded-full shadow-md"></div>
              <div className="absolute bottom-16 right-0 w-3 h-3 bg-[#fff301] rounded-full shadow-md"></div>
              <div className="absolute -bottom-6 right-1/3 w-5 h-5 bg-[#e6dd01] rounded-full shadow-md"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
